import React, { useState, useEffect } from "react";
import { Select } from "antd";
import { sortBy } from "lodash";
import { connect } from "react-redux";

const ReinvoiceInfos = ({
  currentClient,
  reinvoiceInfosToModify = null,
  userClients,
  value: client = {},
  onChange
}) => {
  const [clientId, setClientId] = useState(null);
  const triggerChange = changedData => {
    onChange(Object.assign({}, client, changedData));
  };

  useEffect(() => {
    if (!reinvoiceInfosToModify) {
      onChange(Object.assign({}, client, { client_id: currentClient.id }));
      setClientId(currentClient.id);
    }
  }, [currentClient]);

  useEffect(() => {
    if (reinvoiceInfosToModify) setClientId(reinvoiceInfosToModify.client_id);
  }, [reinvoiceInfosToModify]);

  return (
    <div className="flex flex-col">
      <div className="my-2">
        <div className="pb-2 font-bold">Nom du client</div>
        <Select
          placeholder={"Choisir un utilisateur"}
          onChange={clientSelectedId => {
            triggerChange({ client_id: clientSelectedId });
            setClientId(clientSelectedId);
          }}
          value={clientId}
        >
          {userClients &&
            sortBy(userClients, item => item.label).map(item => (
              <Select.Option key={item.id} value={item.id}>
                {item.label}
              </Select.Option>
            ))}
        </Select>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    currentClient: state.currentClient,
    userClients: state.userInfos.clients
  };
};

export default connect(mapStateToProps)(ReinvoiceInfos);



// WEBPACK FOOTER //
// src/modules/presence/components/Form/ReinvoiceInfos.form.js